import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import _notification from 'modules/notification';
import { Card, Table, Modal, Icon } from 'antd';
import EmptyState from 'components/enterprise/EmptyState';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import PageHeader from 'components/enterprise/PageHeader';
import HeaderSearchBox from 'components/table/HeaderSearchBox';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import InputCheck from 'components/controls/InputCheck';
import ButtonComponent from 'components/controls/Button';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';

class DegreeMaster_new extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 10, current: 1 },
            highlightedRowID: 0,
            data: [],
            rowData: {},
            loading: false,
            showModel: false,
            showMessageBox: false,
            degreeError: "",
        };
    }

    componentDidMount() {
        this.getAllCategory();
    }

    //API operations
    getAllCategory = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let degreeList = await _AdminService.GetAllDegree();
                    //console.log("categoryList Data: ", categoryList.data);

                    const filteredDegreeList = degreeList.data.filter(x =>
                        x.ParentId == null
                    );

                    this.setState({
                        ...this.state,
                        data: filteredDegreeList,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleUpdate = async (input) => {
        if (this.validateFormData()) {
            return
        }

        const params = {
            Qualification_Name: this.state.rowData.Qualification_Name.trim(),
            Qualification_Specilisation: this.state.rowData.Qualification_Specilisation,
            ParentId: this.state.rowData.ParentId,
            IsMandetory: this.state.rowData.IsMandetory,
            Id: this.state.rowData.Id
        }

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.CreateDegree(params);
                    //console.log("Post response: ", response);
                    if (response.status == 200) {
                        _notification.showMessage('success', "Degree saved successfully.");
                        this.setState({
                            degreeError: "",
                            showModel: false,
                            loading: false,
                            highlightedRowID: params.Id
                        });
                        this.getAllCategory();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    deletePost = async (value) => {
        const params = {
            Name: this.state.rowData.Name,
            Id: this.state.rowData.Id
        }

        //console.log("Final data: ", params);
        try {
            const response = await _AdminService.DeleteDegree(this.state.rowData.Id);
            //console.log("Post response: ", response);
            if (response.status == 200 && response.data.IsSuccess) {
                _notification.showMessage('success', "Degree deleted successfully.");
                this.setState({
                    degreeError: "",
                    showModel: false
                });
                this.getAllCategory();
            }
            else {
                _notification.showMessage('error', response.data.Message);
            }
        } catch (e) {
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }
    }

    //Table action link clicks
    onEditClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showModel: true, highlightedRowID: 0 }, () => {
            window.scrollTo(0, 0);
        });
    };

    onDeleteClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showMessageBox: true, highlightedRowID: 0 });
    };

    onTableAction = (pagination, filters, sorter, extra) => {
        //console.log('onTableAction ', pagination, filters, sorter, extra);
        this.setState({ pagination: pagination, highlightedRowID: 0 });
    }

    handleSearch = (selectedKeys, confirm, dataIndex) => () => {
        confirm();
        this.setState({ searchText: selectedKeys[0], searchedColumn: dataIndex });
    }

    handleReset = (clearFilters, dataIndex) => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <HeaderSearchBox
                setSelectedKeys={setSelectedKeys}
                selectedKeys={selectedKeys}
                confirm={confirm}
                clearFilters={clearFilters}
                stateName={dataIndex}
                handleSearch={this.handleSearch}
                handleReset={this.handleReset}
            />
        ),
        filterIcon: (filtered) => <Icon type="search" style={{ color: filtered ? 'var(--admin-primary)' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : false,
    })

    //Message box confirm delete click
    onConfirmDelete = (value) => {
        //console.log('reached in delete:  ', value);
        this.setState({ showMessageBox: false });
        this.deletePost(value);
    }

    closeMessageBox(value = false) {
        this.setState({ showMessageBox: value });
    }

    // Add new record click
    onAddNewRecordClick(modelToggle) {
        this.setState({ showModel: modelToggle, rowData: {} });
    }

    hideModelWindow() {
        this.setState({ showModel: false, rowData: {}, degreeError: '' });
    }

    onTextChange = ({ target: { name, value } }) => {
        if (name == 'Qualification_Name' && value.length > 50)
            return;

        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [name]: value }
        });

        this.setState({ [name]: value.trim() });
    }

    onConfigCheck = event => {
        //console.log(event.target.name, " ", this.state.rowData[event.target.name]);        
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [event.target.name]: !this.state.rowData[event.target.name] }
        });
    };

    validateFormData = () => {
        let body = this.state.rowData;

        this.setState({
            degreeError: '',
        });

        let hasError = false;

        if (!body.Qualification_Name || !body.Qualification_Name.trim()) {
            this.setState({ degreeError: 'Please enter valid Degree Name' });
            hasError = true
        }

        return hasError;
    }

    render() {
        const TableColumns = [
            {
                title: 'Degree Name',
                dataIndex: 'Qualification_Name',
                width: '80%',
                key: 'Qualification_Name',
                // sorter: (a, b) => a.Qualification_Name.length - b.Qualification_Name.length,
                sorter: (a, b) => a.Qualification_Name.localeCompare(b.Qualification_Name),
                ...this.getColumnSearchProps('Qualification_Name'),
            },
            // {
            //     title: 'Mandatory',
            //     dataIndex: 'IsMandetory',                
            //     width: '15%',
            //     key: 'IsMandetory',                
            //     render: (value, row) => { return (value ? "Yes" : "No"); }
            // },
            {
                title: 'Action',
                dataIndex: '',
                key: 'Id',
                render: (value) => {
                    return (
                        <>
                            <ButtonComponent type="button" value="Edit" className="button-global button-border small autoHeight mr-2" onClick={(event) => this.onEditClick(value)} />
                            <ButtonComponent type="button" value="Delete" className="button-global button-danger small autoHeight" onClick={(event) => this.onDeleteClick(value)} />
                        </>
                    );
                }
            },
        ];

        if (this.state.loading)
            return <LoadingSpinner />

        return (
            
                <div className="container-fluid p-3">
                    <PageHeader
                        title="Degree Master"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Degree Master' }]}
                    />
                    <div className="analysisWrap">
                            <div style={{ textAlign: 'right' }}>
                                {!this.state.showModel &&
                                    <div className="max1200 m-auto mb-2"> 
                                        <div className="d-flex align-items-center justify-content-end">
                                            <a className="button-global button-border addbutton   d-inline-block text-center autoHeight mb-3 mr-2 d-flex align-items-center justify-content-center" 
                                            onClick={() => this.onAddNewRecordClick(true)}><Icon type="plus-circle" className="mr-2 font1rem" /> Add Degree</a>
                                
                                        </div>
                                    </div>  
                                }
                            </div>
                        
                        {/* Modal controls */}
                        {this.state.showModel &&            
                            <div className="max1200 m-auto">
                                <div className="ent-panel">
                                    <h4 className="heading4">{this.state.rowData ? this.state.rowData.Id > 0 ? "Update" : "Add" : "Add"} Degree</h4>
                                    <div className="admin-inner-wrap p-3">
                                        <div className="row flex-sm-row ">
                                            <div className="mb-2 col-sm-4">
                                                <MyInput id="Qualification_Name"
                                                    type="text"
                                                    key="Qualification_Name"
                                                    name="Qualification_Name"
                                                    heading="Degree Name"
                                                    value={this.state.rowData.Qualification_Name ? this.state.rowData.Qualification_Name : ""}
                                                    onChange={this.onTextChange}
                                                    isRequired={true}
                                                    errorState={this.state.degreeError}
                                                    errorMessage={this.state.degreeError} />
                                            </div>
                                            {/* <div className="mb-2 col-sm-4">
                                                <label htmlFor="category">Make Degree Field Mandatory<span className="color-red">*</span></label>
                                                <InputCheck
                                                    id="IsMandetory"
                                                    type="checkbox"
                                                    label="Mandatory"
                                                    className="mt-4"
                                                    name="IsMandetory"
                                                    value="false"
                                                    onChange={this.onConfigCheck}
                                                    checked={this.state.rowData.IsMandetory ? this.state.rowData.IsMandetory : false}
                                                />
                                            </div> */}
                                        </div>     
                                    </div>
                                    <div className="pt-4 buttonAlignCenter" >
                                        <ButtonComponent type="button" value="Cancel" onClick={() => this.hideModelWindow()} className="button-global button-secondary mr-4 autoHeight small" />
                                        <ButtonComponent type="button" value="Save" onClick={this.handleUpdate} className="button-global button-primary autoHeight small" disabled={this.state.loading} />
                                    </div>
                                </div>
                            </div>  
                        }
                        <div className="max1200 m-auto">
                            <Table size='small'
                                bordered
                                rowKey='Id'
                                columns={TableColumns}
                                dataSource={this.state.data}
                                pagination={this.state.pagination}
                                footer={() => <label style={{ textAlign: 'right', marginRight: '20px' }}>Total Records: {this.state.data.length}</label>}
                                onChange={this.onTableAction}
                                rowClassName={(record, index) => (index % 2 ? 'odd' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : '') :
                                    'even' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : ''))}
                                className="table-striped-rows admin-table"
                                locale={{ emptyText: <EmptyState icon="inbox" title="No Records Found" description="No degrees have been added yet." /> }}
                            />
                        </div>
                    </div>

                    <Modal
                        centered={true}
                        width={400}
                        // bodyStyle={{
                        //     height: "150px",
                        //     padding: 0,
                        //     alignItems: "center",
                        //     justifyContent: "center",
                        //     display: " flex"
                        // }}
                        className="modelPopAnt admin-home"
                        visible={this.state.showMessageBox}
                        onCancel={() => this.closeMessageBox(false)}
                        footer={false}
                    >
                        <ConfirmPopup
                            onCancel={() => this.closeMessageBox(false)}
                            onOk={this.onConfirmDelete}
                            popupData={this.state.rowData}
                            message="Are you sure, you want to delete this Degree?"
                        />
                    </Modal>
                </div>
        )
    };
}

export default DegreeMaster_new;